var _style, _g, _g2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n\t.st1{opacity:0.5;}\n\t.st2{fill:none;stroke:#050505;stroke-width:0.7383;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,22.4c-0.2,0-0.3,0-0.5-0.1c-0.3-0.2-0.5-0.6-0.5-1l0.3-3.9c-2-1.7-3.2-4.1-3.2-6.5c0-5.1,4.9-9.3,11-9.3 s11,4.2,11,9.3c0,5.1-4.9,9.3-11,9.3c-1.2,0-2.3-0.1-3.3-0.4l-3.2,2.4C5.3,22.3,5.1,22.4,4.8,22.4z M12,3.6c-5,0-9,3.3-9,7.3 c0,2,1,3.9,2.8,5.3c0.3,0.2,0.4,0.5,0.4,0.9L6,19.3l1.8-1.4c0.3-0.2,0.6-0.3,0.9-0.2c1,0.3,2.1,0.5,3.2,0.5c5,0,9-3.3,9-7.3 C21,6.9,17,3.6,12,3.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8.1,
    cy: 10.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 10.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.9,
    cy: 10.9,
    r: 1.1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 4.1,
    y1: 18.6,
    x2: 4.1,
    y2: 18.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.59c8956bb056960487616cf23957debd.svg";
export { ForwardRef as ReactComponent };